import { createContext } from "react";

export type MenuContextType = {
    open: boolean,
    setOpen: (open: boolean) => void;
};

export const MenuContext = createContext<MenuContextType | null>(null);
